export const Ctrl = 'ctrl'

export const Alt = 'alt'

export const None = ''
